var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.appLoading),expression:"appLoading",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"id":"app","data-i18n":_vm.i18nLocale,"data-theme":_vm.theme}},[(_vm.initOk)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }